module.exports = __webpack_public_path__ + "static/media/ribbon_notif.a1ee9e5d.svg";